import { Component, EventEmitter, OnInit, OnChanges, OnDestroy, Input, Output } from '@angular/core';

declare let Notification: any;

@Component({
  selector: 'push-notification',
  styles: ':host { display: none; }',
  template: '',
  standalone: false,
})
export class PushNotificationComponent implements OnInit, OnDestroy {
  @Input() title: string;
  @Input() body: string;
  @Input() icon: string;
  @Input() sound: string;
  @Input() data: any;
  @Input() tag: string;
  @Input() dir: string = 'auto';
  @Input() lang: string = 'en-US';
  @Input() renotify: boolean = false;
  @Input() sticky: boolean = false;
  @Input() vibrate: Array<number>;
  @Input() noscreen: boolean = false;
  @Input() silent: boolean = true;
  @Input() closeDelay: number = 0;

  @Output('load') onLoad: EventEmitter<any> = new EventEmitter();
  @Output('show') onShow: EventEmitter<any> = new EventEmitter();
  @Output('close') onClose: EventEmitter<any> = new EventEmitter();
  @Output('error') onError: EventEmitter<any> = new EventEmitter();
  @Output('action') onClick: EventEmitter<any> = new EventEmitter();

  private instances: Notification[] = [];

  public checkCompatibility() {
    return !!('Notification' in window);
  }

  public isPermissionGranted(permission) {
    return permission === 'granted';
  }

  public requestPermission(callback) {
    return Notification.requestPermission(callback);
  }

  public show() {
    if (!this.checkCompatibility()) {
      return console.log('Notification API not available in this browser.');
    }

    return this.requestPermission((permission) => {
      if (this.isPermissionGranted(permission)) {
        this.create();
      }
    });
  }

  public create() {
    const notification = new Notification(this.title, {
      dir: this.dir,
      lang: this.lang,
      data: this.data,
      tag: this.tag,
      body: this.body,
      icon: this.icon,
      silent: this.silent,
      sound: this.sound,
      renotify: this.renotify,
      sticky: this.sticky,
      vibrate: this.vibrate,
      noscreen: this.noscreen,
    });

    this.instances.push(notification);
    this.attachEventHandlers(notification);
    this.close(notification);

    return notification;
  }

  public close(notification): void {
    if (this.closeDelay) {
      setTimeout(() => {
        notification.close();
      }, this.closeDelay);
    } else {
      notification.close();
    }
  }

  public closeAll(): void {
    this.instances.forEach((notification) => this.close(notification));
    this.instances = [];
  }

  attachEventHandlers(notification): void {
    notification.onshow = () => {
      this.onShow.emit({ notification });
    };

    notification.onclick = (event) => {
      this.onClick.emit({ event, notification });
    };

    notification.onerror = () => {
      this.onError.emit({ notification });
    };

    notification.onclose = () => {
      this.onClose.emit({ notification });
    };
  }

  public ngOnInit(): void {
    this.onLoad.emit({});
  }

  public ngOnDestroy(): void {
    this.closeAll();
  }
}
